import React from "react";
import ReactDOM from "react-dom";
import HexModal from "../../app/components/modals/HexModal";
import { findModels } from "../../infrastructure/repository/benefit-models-repository";
import {
  findCompanyId,
  findCompanyDetail,
} from "../../infrastructure/repository/company-repository";
import ShowDetailEmployee from "../../app/components/modals/employee/showDetailEmployee";
import { showErrorMessage } from "../commons/show-error-message";
import Employee from "../../app/domain/Employee";
import { logError, addContextLog } from "../../infrastructure/log";
import { translate } from "../../infrastructure/translate/localization";
import { shouldFilterTaxRegimes } from "../../infrastructure/country-rules";

function renderNewEmployeeModal({ employee, benefitModels, taxRegimes }) {
  ReactDOM.render(
    <HexModal>
      <ShowDetailEmployee
        employee={employee}
        benefitModels={benefitModels}
        taxRegimes={taxRegimes}
        editType="newEmployee"
      />
    </HexModal>,
    document.getElementById("modal-container")
  );
}

export async function createNewEmployee() {
  try {
    const employee = {};
    const companyId = await findCompanyId();
    const companyDetail = await findCompanyDetail();
    const { data: benefitModels } = await findModels();

    addContextLog("info", "createNewEmployee", "display-screen", {
      companyId,
      employee,
      benefitModels,
    });
    renderNewEmployeeModal({
      employee,
      benefitModels,
      taxRegimes: shouldFilterTaxRegimes(companyDetail.data.countryISO2Code)
        ? [Employee.taxRegimes[0]]
        : Employee.taxRegimes,
    });
  } catch (e) {
    logError(e, `Error to createNewEmployee`);
    showErrorMessage(translate("common-messages.basic-error-message"), true, e);
  }
}
